
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { DisplayPipesModule } from '../pipes/display/display-pipes.module';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { DxRadioGroupModule, DxDataGridModule } from 'devextreme-angular';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzIconModule } from 'ng-zorro-antd/icon';
@NgModule({
  declarations: [
  ],
  imports: [
    DisplayPipesModule,
    CommonModule,
    NzTreeSelectModule,
    NzSelectModule,
    FormsModule,
    NzModalModule,
    NzButtonModule,
    NzDatePickerModule,
    NzTableModule,
    NzSpinModule,
    DxRadioGroupModule,
    NzRadioModule,
    DxDataGridModule,
    NzFormModule,
    NzDescriptionsModule,
    NzUploadModule,
    NzIconModule
  ],
  exports:[
  ]
})
export class ModalsModule { }
